{
  "title": "FBO Activity Tracker",
  "comingSoonTitle": "Coming Soon",
  "comingSoonDescription": "This feature will display activity tracking for each FBO account.",
  "fboAccountsTitle": "FBO Accounts ({{count}}):",
  "activityDataComingSoon": "Activity data coming soon"
}
